var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebpackDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#242938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.222 18L225.443 73V183L128.222 238L31 183V73L128.222 18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.082 179.205L131.43 222.563V188.793L179.188 162.522L208.082 179.205ZM213.325 174.457V83.7798L185.275 99.9682V158.25L213.325 174.457ZM48.05 179.205L124.702 222.563V188.793L76.9433 162.522L48.05 179.205V179.205ZM42.8066 174.457V83.7798L70.8566 99.9682V158.25L42.8066 174.457V174.457ZM46.0883 77.9132L124.702 33.4365V66.0882L74.34 93.7899L73.955 94.0099L46.0883 77.9132V77.9132ZM210.043 77.9132L131.43 33.4365V66.0882L181.792 93.7899L182.177 94.0099L210.043 77.9132V77.9132Z",
    fill: "#8ED6FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.702 181.111L77.585 155.206V103.873L124.702 131.08V181.111ZM131.43 181.111L178.547 155.206V103.873L131.43 131.08V181.111ZM80.775 97.933L128.075 71.918L175.375 97.933L128.075 125.25L80.775 97.933V97.933Z",
    fill: "#1C78C0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpackDark);
export default __webpack_public_path__ + "static/media/Webpack-Dark.b1bfc209bebe4c3cad1829df3cf033c0.svg";
export { ForwardRef as ReactComponent };